"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useControlEvents_1 = __importDefault(require("../../hooks/useControlEvents"));
const useOnLoad_1 = __importDefault(require("../../hooks/useOnLoad"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const SwitchRenderer = (({ style, control, }) => {
    const { Render, functions: { processor } } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const events = (0, useControlEvents_1.default)(control);
    (0, useOnLoad_1.default)(control, events);
    const onValueChange = (0, react_1.useCallback)((newValue) => {
        if (events.onValueChange) {
            events.onValueChange(newValue);
        }
        processor.root.updateControlById({
            control,
            dataToUpdate: {
                value: newValue,
            },
        });
    }, [events, control, processor]);
    const containerStyle = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, style), { alignItems: 'center', justifyContent: 'center' })), [style]);
    const switchStyle = (0, react_1.useMemo)(() => ({
        trackColorActive: style.trackColorActive || '#9e9e9e',
        trackColorDisiabled: style.trackColorDisiabled || '#9e9e9e',
        thumbColorActive: style.thumbColorActive,
        thumbColorDisiabled: style.thumbColorDisiabled,
    }), [style]);
    return (react_1.default.createElement(Render.View, { style: containerStyle },
        react_1.default.createElement(Render.Switch, { value: !!control.value, trackColor: {
                false: switchStyle.trackColorDisiabled,
                true: switchStyle.trackColorActive,
            }, ios_backgroundColor: control.value ? switchStyle.trackColorActive
                : switchStyle.trackColorDisiabled, thumbColor: control.value ? switchStyle.thumbColorActive
                : switchStyle.thumbColorDisiabled, onValueChange: onValueChange })));
});
exports.default = SwitchRenderer;
